/**
 * Define user roles
 */
export enum Permission {
  ADMIN_GENERIQUE = 'ADMIN_GENERIQUE',
  CL = 'CL',
  CL_PM = 'CL_PM',
  DELEGUE = 'DELEGUE',
  DELEGUE_GENERIQUE = 'DELEGUE_GENERIQUE',
  DELEGUE_PM = 'DELEGUE_PM',
  GAE = 'GAE',
  GARS = 'GARS',
  MANDATAIRE = 'MANDATAIRE',
  REPRESENTANT_LEGAL = 'REPRESENTANT_LEGAL',
}
